module.exports = __webpack_public_path__ + "img/frame08_normal.d448fb92.png";